import React, {useContext, useState, useRef} from "react";
import {Button, Accordion, Card, Form, InputGroup} from 'react-bootstrap';
import { isMobile } from 'react-device-detect';
import FormInput from "./FormInput";
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import AccordionContext from 'react-bootstrap/AccordionContext';
//import images
import collapse from '../images/versions/collapse.png';
import expand from '../images/versions/expand.png';
//import style
import '../styles/custom-form.css';


function ContextAwareToggle({ children, eventKey, callback }) {
    const { activeEventKey } = useContext(AccordionContext);

    const decoratedOnClick = useAccordionButton(
        eventKey,
        () => callback && callback(eventKey),
    );

    const isCurrentEventKey = activeEventKey === eventKey;

    return (
        <button
        type="button"
        style={{backgroundImage: isCurrentEventKey ? `url("${collapse}"` : `url("${expand}")`,backgroundSize: '100% 100%',border:"0",width:"60px"}}
        onClick={decoratedOnClick}
        >
        {children}
        </button>
    );
}

function VersionCard({id, title, componentCount, active, description, source, createdAt, updatedAt, objectID, resetVersions})
{
    async function updateVersion()
    {
        let updateResults = await fetch(`/version/${objectID}`,{
            method: "PUT",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(fieldValues)
        });
        //get json from results
        let results = await updateResults.json();
        //check results
        if(results.error === undefined)
        {
            setUnsavedChanges([]);
            setSaveDisplay("none");
            resetVersions();
        }
    }

    async function deleteVersion()
    {
        let deleteResults = await fetch(`/version/${objectID}`,{
            method: "DELETE",
            headers: {
                "Content-Type": "application/json"
            }
        });
        //get json from results
        let results = await deleteResults.json();
        //check results
        if(results.error === undefined)
        {
            setUnsavedChanges([]);
            setSaveDisplay("none");
            resetVersions();
        }
    }

    const [fieldValues,setFieldValues] = useState({
        name: title,
        description: description,
        active: active,
        source: source || ""
    });

    function handleChange(event, fieldID)
    {
        let newFields = {...fieldValues};
        let value = event.target.value;
        if(fieldID === 'active')
        {
            value = event.target.checked;
        }
        newFields[fieldID] = value;
        setFieldValues(newFields);
    }

    const [saveDisplay,setSaveDisplay] = useState("none");

    const [unsavedChanges,setUnsavedChanges] = useState([]);

    function compareCurrentValueWithInitial(event)
    {
        let initial = event.target.getAttribute("initial");
        let value = event.target.value;
        let id = event.target.getAttribute("id");
        if(id == "active")
        {
            value = event.target.checked.toString();
        }
        if(value !== initial && saveDisplay === "none")
        {
            setSaveDisplay("");
            const updatedUnsavedChanges = [...unsavedChanges,event.target];
            setUnsavedChanges(updatedUnsavedChanges);
        }else if(value == initial)
        {
            for(let a = 0;a < unsavedChanges.length;a++)
            {
                if(unsavedChanges[a].getAttribute("id") === id)
                {
                    //remove current selection from array
                    const updatedUnsavedChanges = unsavedChanges;
                    updatedUnsavedChanges.splice(a,1);
                    setUnsavedChanges(updatedUnsavedChanges);
                    break;
                }
            }
            if(unsavedChanges.length === 0)
            {
                setSaveDisplay("none");
            }
        }
    }

    function formatDateTime(timestamp)
    {
        let dateObj = new Date(Date.parse(timestamp));
        let hour = dateObj.getHours();
        let result = hour;
        let minutes = dateObj.getMinutes();
        let ext = '';
        if(hour > 12)
        {
            ext = 'PM';
            hour = (hour - 12);
            if(hour < 10)
            {
                result = "0" + hour;
            }else if(hour == 12)
            {
                hour = "00";
                ext = 'AM';
            }
        }
        else if(hour < 12)
        {
            result = ((hour < 10) ? "0" + hour : hour);
            ext = 'AM';
        }else if(hour == 12)
        {
            ext = 'PM';
        }
        if(minutes < 10){
            minutes = "0" + minutes; 
        }
        return `${dateObj.getMonth()+1}/${dateObj.getDate()}/${dateObj.getFullYear()} ${result}:${minutes} ${ext}`;
    }

    let direction = "row";
    if(isMobile)
    {
        direction = "column";
    }

    return (
        <Accordion id={id} defaultActiveKey="1" className="mb-2">
            <Card>
                <Card.Header style={{padding:"0",margin:"0",display:"flex"}} className="my-auto">
                    <button style={{width:"100%",height:"50px",paddingLeft:"15px",border:"none",textAlign:"left"}} onClick={()=>{window.location = `/components/${objectID}`}}>{componentCount ? `${title} - Components: ${componentCount}` : title}</button>
                    <ContextAwareToggle className="my-auto" eventKey="0"/>
                </Card.Header>
                <Accordion.Collapse eventKey="0">
                    <Card.Body>
                        <div style={{display:"flex",justifyContent:"right",marginBottom:"10px"}}>
                            <Button variant='success' size='sm' style={{marginRight:"10px",display:saveDisplay}} onClick={updateVersion}>Save</Button>
                            <Button variant='secondary' size='sm' onClick={deleteVersion}>Delete</Button>
                        </div>
                        <div style={{display:"flex",flexDirection:direction}}>
                            <FormInput id='name' title='Name' value={fieldValues['name']} marginRight='10px' initial={title} onChange={(event,id)=>{compareCurrentValueWithInitial(event);handleChange(event,id)}}/>
                            <FormInput id='description' title='Description' value={fieldValues['description']} initial={description} onChange={(event,id)=>{compareCurrentValueWithInitial(event);handleChange(event,id)}}/>
                        </div>
                        <div style={{display:"flex"}}>
                            <InputGroup.Text className="mb-2 me-2">Active</InputGroup.Text>
                            <Form.Check initial={active.toString()} checked={fieldValues['active']} onChange={(event)=>{handleChange(event,'active');compareCurrentValueWithInitial(event)}} type='checkbox' id='active' className="mt-1 me-4"/>
                            <FormInput id='source' title='Source' value={source} readOnly={true}/>
                        </div>
                        <div style={{display:"flex",justifyContent:"space-between",marginTop:"15px",fontWeight:"lighter"}}>
                            {
                                createdAt && 
                                <h6 className="mb-0" style={{fontWeight:"normal"}}>{`Created: ${formatDateTime(createdAt)}`}</h6>
                            }
                            {
                                updatedAt &&
                                <h6 className="mb-0" style={{fontWeight:"normal"}}>{`Updated: ${formatDateTime(updatedAt)}`}</h6>
                            }
                        </div>
                    </Card.Body>
                </Accordion.Collapse>
            </Card>
        </Accordion>
    );
}

export default VersionCard;